import { color } from "framer-motion";
import Pic from "../images/folder.png"
import { Card, Col, Row } from 'react-bootstrap';

const posts = [
  {
    id: 1,
    web: 'Will Bangkok Clinic',
    title: 'Designing and Developing a Beauty Clinic Website with Figma and WordPress',
    href: 'https://www.figma.com/proto/uSHQKu32b0bWKTjly5LfTy/Will-Clinic?node-id=1-3&starting-point-node-id=1%3A3',
    description:
      'A beauty clinic website design and development project using Figma and WordPress.',
    tools: [
      'Figma',
      'WordPress'
    ]
  },
  {
    id: 2,
    web: 'Color Hub',
    title: 'Designing and Developing with Figma and WordPress',
    href: 'https://www.figma.com/proto/TilXVEbg5ZbYVr7lAXE9LA/colorhubthailand?node-id=2-6',
    description:
      'Another project focusing on the design and development using Figma and WordPress.',
    tools: [
      'Figma',
      'WordPress'
    ]
  },
  {
    id: 3,
    web: 'Flex message',
    title: 'Daily Sales Notification',
    href: 'https://www.figma.com/proto/uPvVXYEgtZ2fJeW1ab0pnu/Flex-Messages?node-id=1-2',
    description:
      'A daily sales notification system involving Figma, Flex Message, and App Script.',
    tools: [
      'Figma',
      'flex message',
      'app script'
    ]
  },
]

export default function FigmaProjects() {
  return (
    <Row className="g-4 mb-10 ">
      {posts.map((post) => (
        <Col key={post.id} xxl={4} xl={4} lg={4} md={6} sm={12}>
          <a href={post.href} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
            <Card className="h-100 bg-figma custom-rounded transition-transform duration-300 transform hover:scale-105 p-3 hover-soak">
              <Card.Body>
                {/* Icon */}
                <div className="d-flex align-items-center gap-2 mb-2">
                  <Card.Img
                    variant="top"
                    src={Pic}
                    alt="Figma icon"
                    style={{ width: 24, height: 24, objectFit: 'contain' }}
                    className="mb-2"
                  />
                </div>

                {/* Title */}
                <Card.Title className="text-main mb-3">{post.web}</Card.Title>

                {/* Subtitle */}
                <Card.Subtitle className="mb-2 text-jobs">{post.title}</Card.Subtitle>

                {/* Description */}
                <Card.Text className="text-white">{post.description}</Card.Text>

                {/* Tools */}
                <div className="mt-3">
                  <strong className="text-jobs">Tools: </strong>
                  {post.tools.map((tool, index) => (
                    <span key={index} className="text-jobs">
                      {tool}
                      {index < post.tools.length - 1 && ', '}
                    </span>
                  ))}
                </div>
              </Card.Body>
            </Card>
          </a>
        </Col>
      ))}
    </Row>

  )
}
